export enum EPitchStatus {
  application = "application",
  draft = "draft",
  pending = "pending",
  live_unlisted = "live_unlisted",
  live_listed = "live_listed",
  finished = "finished",
  post_process = "post_process",
  closed = "closed",
  exited = "exited",
  refunded = "refunded",
  rejected = "rejected"
}
